import _ from 'lodash'
import appDisplay from 'scoreboard/components/app-display'
import i18n from 'scoreboard/components/i18n'
import StrongConfirmPrompt from '../components/strong-confirm-prompt'

/**
 * Common concerns for dealing with organizations
 */
class OrgHelper {

	/**
	 * Handles a XHR error response requiring the user to accept that
	 * org copies will be deleted.
	 *
	 * @param {Backbone.Model<Organization>} {options.node} The node that was selected for deletion
	 *
	 * @param {Object} options.response The xhr.responseJSON object
	 *
	 * @param {Object} options.tree The kalpa tree object (from the gardener)
	 *
	 * @param {Function<XMLHttpRequest>} options.confirmXHR A function that generates the request
	 * to send when the user clicks 'confirm'
	 *
	 * @return {DeleteConfirmation} The Backbone view, can be used to add additional events (e.g. undo)
	 */
	copyDeletionDialog(options) {

		const {node, response, tree, confirmXHR} = options
		// The server indicated that the attempted move will cause other orgs to
		// be deleted (ex. moving a template org out of its template tree). Give
		// the user a delete confirmation dialog
		var copiesToDelete = response.copies

		var message = response.message + this.htmlList(copiesToDelete)

		var confirmationView = new StrongConfirmPrompt({
			message: message,
			label: node.label,
			prompt: i18n.get('common.delete.typeDelete'),
			dialogTitle: i18n.get('template.moveTriggersCopyDeletion.dialogTitle')
		})

		// If the user confirms the deletion, send the paste XHR again
		// with confirmed=true
		confirmationView.on('confirm', () => {
			confirmXHR().done(() => {
				// Now that the move is done, remove the copies that will be deleted from the tree
				copiesToDelete.forEach(c => tree.removeNode(c.id))
				confirmationView.trigger('done')
			})
		})

		appDisplay.dialog(confirmationView)
		return confirmationView
	}

	/**
	 * @param {Backbone.Model<Organization>} orgs
	 * @return {String} html string of unordered list of node labels
	 */
	htmlList(orgs) {
		const itemReducer = (html, idLabel) => `${html}<li>${_.escape(idLabel.label)}</li>`
		return `<ul>${_.reduce(orgs, itemReducer, '')}</ul>`
	}
}

const orgHelper = new OrgHelper()
export default orgHelper
orgHelper.__filename__ = 'organizations/org-helper.js'
